import { REVIEW_IMAGES_MAX, type ReviewImageView } from '@repo/api-contracts';
import { trpc } from '@/shared/api';
import { useImageUploadQueue } from '@/shared/lib';

export const useReviewImageUploads = (initial: readonly ReviewImageView[]) => {
  const presign = trpc.myReviews.presignImage.useMutation();
  const confirm = trpc.myReviews.confirmImage.useMutation();
  return useImageUploadQueue({
    max: REVIEW_IMAGES_MAX,
    initial,
    presign: (contentType) => presign.mutateAsync({ contentType }),
    confirm: (imageId) => confirm.mutateAsync({ imageId }),
  });
};
